export default __webpack_public_path__ + "static/media/833926.528fbfa5.png";